import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const MAP = {
  profile: '/profile',
  form: '/my-form',
  preferences: '/match-preferences',
  connect: '/connect',
  inbox: '/inbox',
  settings: '/settings',
};

export default function DashboardPage() {
  const [params] = useSearchParams();
  return <Navigate to={MAP[params.get('tab')] || '/profile'} replace />;
}
